import { useState } from "react";

type Props = {
  sources: string[];
  alt: string;
  testId?: string;
};

export function ReferenceImage({ sources, alt, testId }: Props) {
  return <ReferenceImageContent key={sources.join("\n")} sources={sources} alt={alt} testId={testId} />;
}

function ReferenceImageContent({ sources, alt, testId }: Props) {
  const [sourceIndex, setSourceIndex] = useState(0);
  const source = sources[sourceIndex];

  return <div className="flex aspect-square w-full items-center justify-center overflow-hidden rounded-t-xl bg-violet-50/80 p-2 sm:p-3">
    {source ? <img
      key={source}
      src={source}
      alt={alt}
      data-testid={testId}
      className="h-full w-full object-contain"
      onError={() => setSourceIndex((index) => Math.min(index + 1, sources.length))}
    /> : <div role="status" className="flex h-full w-full flex-col items-center justify-center gap-2 rounded-lg border border-dashed border-violet-200 bg-violet-50 px-4 text-center text-xs font-medium text-violet-700">
      <span className="text-2xl leading-none" aria-hidden="true">—</span>
      Preview unavailable
    </div>}
  </div>;
}
